export default {
      id: "arrow-right-usage",
      viewBox: "0 0 23 15",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#arrow-right",
      toString: function () {
        return this.url;
      }
    }